const convertToDecimalWithTwoDigits = (number) => {
    // Mengonversi angka menjadi string dengan dua digit desimal di belakang koma
    const decimalNumber = parseFloat(number).toFixed(2);
    return decimalNumber;
}

export default convertToDecimalWithTwoDigits